const actions = {
  FETCH_DEVICE_EVENTS: 'FETCH_DEVICE_EVENTS',
  FETCH_DEVICE_EVENTS_SUCCESS: 'FETCH_DEVICE_EVENTS_SUCCESS',
  FETCH_DEVICE_EVENTS_ERROR: 'FETCH_DEVICE_EVENTS_ERROR',

  fetchDeviceEvents: (search) => ({
    type: actions.FETCH_DEVICE_EVENTS,
    search,
  }),

  fetchDeviceEventsSuccess: (deviceEvents) => ({
    type: actions.FETCH_DEVICE_EVENTS_SUCCESS,
    deviceEvents,
  })
};

export default actions;
